import { ClientCartAction, ClientCartActionCartRef, SwarovskiOptikClientCart } from "@swo/storefront";
import { Either } from "fp-ts/es6/Either";
import { performCartAction } from "../perform-cart-action";
import { ClientCartCheckoutShippingChangeAction } from "../../../types";
import { SwarovskiOptikErrorClientResponse } from "../../types";

export const checkoutShipping = (
  token: string,
  localeCode: string,
  segmentKey: string,
  _cartRef: ClientCartActionCartRef,
  payload: ClientCartCheckoutShippingChangeAction,
  baseUrl?: URL,
): Promise<Either<SwarovskiOptikErrorClientResponse, SwarovskiOptikClientCart>> => {
  const cartRef: ClientCartActionCartRef = {
    id: _cartRef.id,
    version: _cartRef.version,
  };

  const actionBody: ClientCartAction =
    payload.kind === "parcel-shipping"
      ? {
          tag: "checkout-shipping-change",
          cartRef: cartRef,
          method: {
            kind: "parcel-shipping",
            id: payload.id,
            shippingAddress: payload.shippingAddress,
          },
        }
      : payload.kind === "digital"
        ? {
            tag: "checkout-shipping-change",
            cartRef: cartRef,
            method: {
              kind: "digital",
              id: payload.id,
            },
          }
        : {
            tag: "checkout-shipping-change",
            cartRef: cartRef,
            method: {
              kind: "dealer-pickup",
              id: payload.id,
              dealerId: payload.dealerId,
            },
          };

  return performCartAction(token, localeCode, segmentKey, baseUrl)(actionBody);
};
